<h6>Multicompany associate</h6>
<div *ngIf="subscriptionFound">
    <!-- grid multicompany in essere (codice subscription, ragione sociale, piva?)-->
    <table mat-table [dataSource]="dataSourceSubscription" style="width: 100%; height: 100%" matSort>
        <ng-container matColumnDef="CompanyName">
            <th mat-header-cell *matHeaderCellDef><mat-label translate>COMMONS.COMPANY_NAME</mat-label></th>
            <td class="td-type" mat-cell *matCellDef="let row">{{ row.Description }}</td>
        </ng-container>

        <ng-container matColumnDef="SubscriptionKey">
            <th mat-header-cell *matHeaderCellDef><mat-label translate>EDIT_SUBSCRIPTION.SUBKEY_CODE</mat-label></th>
            <td class="td-name" mat-cell *matCellDef="let row">{{ row.SubscriptionKey }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsSubscription"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsSubscription" class="pointer"></tr>
    </table>
</div>

<div class="message-box warning" *ngIf="!subscriptionFound">
    <mat-label translate>COMMONS.NO_ELEMENTFOUND</mat-label>
</div>

<div *ngIf="this.multicompanyNr > 0">
    <!-- form anagrafiche con bottone creazione multicompany - si visualizza su click del bottone sopra-->
    <ms-multicompany-creation-button
        [cur_subscriptionKey]="this.currentRow.SubscriptionKey"
        [cur_signature]="this.currentRow.ProductID"
        [disabled]="false"
    >
    </ms-multicompany-creation-button>
</div>
